import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import me from "../assets/me1.jpg";
import { useTranslation } from "react-i18next";

export const Home = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Lander De Kesel";
    window.scrollTo(0, 0);
    AOS.init();
  }, []);

  return (
    <>
      <section className="introContainer">
        <div className="introLeft">
          <p
            data-aos-duration="1000"
            data-aos="fade-right"
            className="introHello"
          >
            {t("home.intro_hello")}
          </p>
          <p
            data-aos-delay="500"
            data-aos-duration="2000"
            data-aos="fade-right"
            className="introName"
          >
            Lander<span style={{ color: "#0077ff" }}>.</span>
          </p>
          <div data-aos-delay="1500" data-aos-duration="1000" data-aos="fade">
            <p className="introDiscription">
              {t("home.intro_description", {
                age: new Date().getFullYear() - 2003,
              })}
            </p>
            <div className="btn-container">
              <Link className="authButtons" to="/portfolio">
                {t("shared.view_portofolio")}
              </Link>
              <Link className="authButtonsReversed" to="/contact">
                {t("shared.contact_me")}
              </Link>
            </div>
          </div>
        </div>
        <div className="introRight">
          <img
            data-aos="zoom-in"
            data-aos-duration="1000"
            className="me"
            src={me}
            alt=""
          />
        </div>
      </section>
    </>
  );
};
